(($, Drupal) => {
  $(setTimeout( function() {
    // Fix multiline text overflowing.
    var ellipsisText = $(".ellipsis-text p");
    if (ellipsisText.length) {
      ellipsisText.ellipsis({
        type: "lines",
        count: 3
      });
    }

    // Apply an additionnal spacing under the hero promotions.
    var heroPromos = $(".hero-promos.multiple");
    if (heroPromos.length) {
      if ($(window).width() > 991) {
        var spacing = heroPromos.outerHeight() / 2;
        heroPromos
          .closest(".hero")
          .next()
          .find(">:first-child")
          .css("padding-top", spacing);
      } else {
        heroPromos.addClass("slider");
      }
    }

    // Add responsive class to all tables
    var tables = $(".components table");
    if (tables.length && !tables.hasClass("table")) {
      tables.addClass("table");
      if (tables.length) {
        $(".table").wrap(function() {
          return "<div class='table-responsive'></div>";
        });
      }
    }

    // For testimonials without CTA
    if ($('.testimonials').length) {
      var testimonial = $('.testimonial.slide');
      testimonial.each(function () {
        var extra = $(this).find('.extra');
        var testimonialCTA = extra.find('.btn-container');
        if (testimonialCTA.length == 0) {
          extra.css('justify-content', 'space-evenly');
        }
      });
    }
    jQuery(window).on('load resize', function () {
      if (jQuery(window).width() < 992) {
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container').find('.panel-title').attr('aria-expanded', 'false');
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container #edit-container-root--content').removeClass('in');
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container').find('.panel-body').removeClass('in');
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container.views-ef-fieldset-root:first-of-type').find('#edit-container-root--content').addClass('in');
      }
      else {
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container').find('.panel-title').attr('aria-expanded', 'true');
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container').find('.panel-title').toggleClass('collapsed');
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container').find('.collapse').attr('aria-expanded', 'true');
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container #edit-container-root--content').addClass('in');
        jQuery('.view-customer-cards .bef-exposed-form .views-ef-fieldset-container').find('.panel-body').addClass('in');
      }
    });

    $(
      setTimeout(function() {
        if ($(".highcharts-data-labels").length) {
          $(
            ".g2-roi-table .highcharts-data-labels .highcharts-label text"
          ).append("%");
        }
      }),
      600
    );
    // Logic moving comments to bottom of form on mobile for contact webform component
    if (jQuery('.hero-webform').length === 0) {
      if (jQuery('.field--name-field-prg-webform').length) {
        if (jQuery('.form-item-comments').length) {
          jQuery(window).on('load resize', function () {
            if (jQuery(window).width() < 992) {
              if (jQuery('#edit-industry-interest').length) {
                jQuery(".form-item-comments").first().appendTo("#edit-industry-interest");
              }
              else if (jQuery('#edit-industry-interest--2').length) {
                jQuery(".form-item-comments").first().appendTo("#edit-industry-interest--2");
              }
            }
            else {
              if (jQuery('#edit-phone-comments').length) {
                jQuery(".form-item-comments").first().appendTo("#edit-phone-comments");
              }
              else if (jQuery('#edit-phone-comments--2').length) {
                jQuery(".form-item-comments").first().appendTo("#edit-phone-comments--2");
              }
            }
          });
        }
      }
    }

    // jQuery(".highcharts-series .highcharts-label text").append(
    //   "%"
    // );
      // TEMPORARY
      // For site alerts (event promo banner appended to top of page)
      // function countVisits(nodeId) {
      //   visited++; // increase page visits counter
      //   // set new cookie value to match visits
      //   $.cookie("visited-" + nodeId, visited, {
      //     expires: 1,
      //     path: '/'
      //   });
      // };

      // Close banner after 3 days or on click 'X'
      // function closeNotification(nodeId) {
      //   var date = new Date();
      //   date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * 3);
      //   $.cookie("hide-notification-" + nodeId, "true", {
      //     expires: date,
      //     path: "/"
      //   });
      //   alertBanner.slideUp(250);
      // };
      var alertBanner = $(".site-alert");
    var nodeId = alertBanner.find("div[class^='background-']").attr("data-site-alert-id");
    if (alertBanner.length && nodeId) {
      // var visited = $.cookie("visited-" + nodeId) || 0;
      // var closed = $.cookie("hide-notification-" + nodeId) || false;
      /* After three visits to a page with the same site alert banner ID (nodeId) the banner will close,
      otherwise 'hidden' class is removed */
      // if (visited < 3 && !closed) {
        alertBanner.removeClass('hidden');
      // }
      // countVisits(nodeId);
      // $(".exit-icon").click(function(event){
      //   closeNotification(nodeId);
      // });
    };

    // Toggle the correct tab on mobile dropdown click.
    if ($(".tabs-component, .faq").length) {
      $(".tabs-component, .faq").each(function() {
        var tabs = $(this);
        tabs.find(".dropdown-menu li").on("click", function() {
          var index = $(this).attr("data-tab-index");
          var title = $(this).text();
          tabs.find(".dropdown .title").text(title);
          tabs
            .find('.nav-tabs .tab-label[data-tab-index="' + index + '"]')
            .trigger("click");
          tabs.find(".dropdown-menu li.active").removeClass("active");
          $(this).toggleClass("active");
        });
        tabs.find(".dropdown-menu li:first-child").click();
      });
    }

    //Function that stops videos playing
    var stopVideos = function (tabs) {
      Array
        .prototype
        .forEach
        .call(tabs, function (tab) {
            var tabVideos = tab.querySelectorAll('iframe, video');
            Array
            .prototype
            .forEach
            .call(tabVideos, function (video) {
              if (video.tagName.toLowerCase() === 'video') {
                video.pause();
                console.log("Video paused");
              } else {
                var src = video.src;
                video.src = src;
              }
            });
        });
    };

    //Pause vimeo embed playing on tab switch (for Tabs component but should also work for FAQ)
    var tabLabels = $('.nav-tabs .tab-label');

    if (tabLabels.length > 1){
      //Using Bootstrap Show event to get the current target and use it to find the related panel to display
      //then go through the siblings of this panel (excluding the targeted panel) with the class tab-pane and pause iframe video if
      //there are iframe in the selected tab-pane(s)
      $('li[data-toggle="tab"]').on('show.bs.tab', function (e) {
          var activeTab = e.target;
          var activeTabIndex = $(activeTab).data("tab-index");
          var activeTabTarget = $(activeTab).data("target");
          var activeTabPane = document.querySelector(activeTabTarget + '.tab-pane'); //example of selection: '.tab-wrapper-11666 .tab-4.tab-pane'
          var tabContent = activeTabPane.closest('.tab-content');
          var otherTabPanes = tabContent.querySelectorAll('.tab-pane:not(.tab-'+ activeTabIndex +')');

          stopVideos(otherTabPanes);
        });
    }

    // Trigger bullets related methods.
    if ($(".bullets").length) {
      var bulletsResizeTimeout;
      if ($(window).width() > 768) {
        alignRowBullets();
        alignGridBullets();
        var bulletsResize = function() {
          clearTimeout(bulletsResizeTimeout);
          bulletsResizeTimeout = setTimeout(() => {
            alignRowBullets();
            alignGridBullets();
          }, 500);
        };
        $(window).on('resize', bulletsResize);
      }
    }

    // Correct the vertical placement of the row bullet item based on the header height.
    function alignRowBullets() {
      const $rowBullets = $(
        '.bullets[data-alignment="2"] .item'
      );
      $rowBullets.each(function() {
        const $header = $(this).find(".item-header");
        const headerHeight = $header.outerHeight();

        if ($(window).width() > 768) {
          let contentHeight = 0;
          $header.find("*:not(img)").each(function() {
            contentHeight += $(this).outerHeight(true);
          });

          const headerRemainingSpace = headerHeight / 2 - contentHeight / 2;
          const headerMarginBottom = 10 - headerRemainingSpace;
          $header.css("margin-bottom", headerMarginBottom + "px");
        }
      });
    }

    // Return the amount of bullets per row depending on the current window size.
    function getBulletsPerRow(defaultAttr) {
      if ($(window).width() <= 992) {
        return 2;
      } else if ($(window).width() <= 1200) {
        return defaultAttr == 2 ? 2 : 3;
      } else if ($(window).width() > 1200) {
        return defaultAttr;
      }
    }

    // Loop through each rows of the bullets component.
    // For every item of a row, set the height of the fields to the same maximum value.
    function alignGridBullets() {
      const $gridBullets = $(
        '.bullets[data-alignment="2"], .bullets[data-alignment="3"], .bullets[data-alignment="4"], .bullets[data-alignment="5"], .bullets[data-alignment="6"]'
      );
      $gridBullets.each(function() {
        const $items = $(this).find(".bullet-item");

        if ($(window).width() > 768) {
          if ($items.length) {
            const itemsPerRow = getBulletsPerRow($(this).attr("data-alignment"));
            const rows = Math.ceil($items.length / itemsPerRow);

            // For every rows..
            for (let rowsIndex = 0; rowsIndex < rows; rowsIndex++) {
              const selectors = [
                ".prg-uppertitle",
                ".bullet-title",
                ".prg-desc",
                ".btn-unwrapped"
              ];

              // For every fields..
              selectors.forEach(function(selector) {
                let maxHeight = 0;
                // Get the max height of the field in all of the items of the row.
                for (let itemsIndex = 0; itemsIndex < itemsPerRow; itemsIndex++) {
                  const itemEq = itemsIndex + rowsIndex * itemsPerRow;
                  const $currentItem = $($items[itemEq]);

                  $currentItem.find(selector).height("initial");
                  const currentH = $currentItem.find(selector).outerHeight();
                  if (currentH > maxHeight) maxHeight = currentH;
                }

                // Set every field to that value.
                for (let itemsIndex = 0; itemsIndex < itemsPerRow; itemsIndex++) {
                  const itemEq = itemsIndex + rowsIndex * itemsPerRow;
                  const $currentItem = $($items[itemEq]);
                  $currentItem.find(selector).height(maxHeight);
                }
              });
            }
          }
        }
      });
    }

    // Assign a number to each bullets found.
    $(".bullets-numbered").each(function() {
      $(this)
        .find(".bullet-item")
        .each(function(i) {
          $(this).addClass("numbered");
          $(this).attr("data-number", i + 1);
        });
    });

    // Old method of smooth scroll
    // Adding anchor ability to indiviual bullets
    // var $bullets = $(".bullets .bullet-item");
    // if ($bullets.length) {
    //   $bullets.each(function () {
    //     var anchorLink = $(this).attr("data-scrollto");
    //     if (anchorLink && $('#' + anchorLink).length > 0) {
    //       var thisOffset = $('#' + anchorLink).offset().top;
    //       $(this).click(function() {
    //         if ($(window).width() < 768) {
    //           var collapsibleDivHeight = $('#' + anchorLink).closest(".mobile-collapsible").height();
    //           if ($('#' + anchorLink).closest(".collapse").not(".in")) {
    //             thisOffset = $('#' + anchorLink).closest(".mobile-collapsible").offset().top - collapsibleDivHeight;
    //             $('#' + anchorLink).closest(".collapse").collapse('toggle').thisOffset;
    //           }
    //         }
    //         $('html,body').animate({
    //           scrollTop: thisOffset
    //         }, 500);
    //       }).css("cursor", "pointer");
    //     }
    //   });
    // };

    // Bleeding component fix.
    if ($(".bleeding").length) {
      $(".bleeding").each(function(i) {
        let element = $(this);
        let columns = element.closest(".columns");
        let component = element.closest(".container").parent();
        let media_column = columns.attr("data-media-column");
        let bleeding_row = element.attr("data-bleeding-row");

        // Only bleed the components that are not in the mobile collapse mode.
        if (!component.hasClass("mobile-collapse-component")) {
          fixMobileBleeding(bleeding_row, media_column, columns);

          let bleedingResizeTimeout;
          var bleedingResize = function() {
            clearTimeout(bleedingResizeTimeout);
            bleedingResizeTimeout = setTimeout(
              fixMobileBleeding(bleeding_row, media_column, columns),
              500
            );
          };
          $(window).on('resize', bleedingResize);

          // Find the next container and apply the bleeding class.
          // That way, the bleeding offset has the right background color.
          const nextComponent =
            bleeding_row == "top" ? component.prev() : component.next();
          nextComponent.addClass("bleeding-container-" + bleeding_row);

          const count = $(".bleeding").length;
          component.css("z-index", count - i);

          if (bleeding_row == "top") {
            recursiveTopBleeding(nextComponent, count - i);
          }

          // If there's a bleeding top component, update the z-index of the previous element.
          // Verify if the previous element is also bleeding top.
          // If so, call the function again.
          function recursiveTopBleeding(component, count) {
            component.css("z-index", count - 1);

            const attr = component.find(".bleeding").attr("data-bleeding-row");
            if (
              typeof attr !== typeof undefined &&
              attr !== false &&
              attr == "top"
            ) {
              recursiveTopBleeding(component.prev(), count - 1);
            }
          }
        }
      });
    }

    // On mobile only, reverse the columns order if they are not correctly positionned.
    function fixMobileBleeding(bleeding_row, media_column, columns) {
      if (
        (bleeding_row == "bottom" && media_column == "left") ||
        (bleeding_row == "top" && media_column == "right")
      ) {
        $(window).width() < 991
          ? columns.addClass("inverse-column")
          : columns.removeClass("inverse-column");
      }
    }

    // If there are any .slider elements on the page, boot them up.
    if ($(".slider").length) {
      initSlider();
    }

    function initSlider() {
      $(".slider").each(function (i) {
        // Give each slider a unique id so event handlers/debugging are easier.
        this.id = `slider${i}`;

        const slider = $(this);

        // Feature flags by slider type (driven by CSS classes).
        const careerSlider = slider.hasClass("careers-slider");
        const videoSlider  = slider.hasClass("video-slider");

        // --- A11y helper: build a useful label for video links -------------------
        // Many screen readers ignore <a title="...">. We drop title and set
        // aria-label using the visible .video-title. If target=_blank, we hint it.
        const labelVideoLinks = ($ctx) => {
          $ctx.find('.slick-slide a.fancyBoxTrigger').each(function () {
            const $a = $(this);
            const titleText = $a.closest('.slick-slide').find('.video-title').text().trim();
            const base = titleText ? `Play video: ${titleText}` : 'Play video';
            const hint = $a.is('[target="_blank"]') ? ' (opens in a new window)' : '';
            $a.removeAttr('title').attr('aria-label', base + hint);
          });
        };

        // --- A11y helper: give each slide a role and position --------------------
        // Example: role="group" aria-roledescription="slide" aria-label="Slide 2 of 5"
        const labelSlides = (slick) => {
          const total = slick.slideCount;
          $(slick.$slides).each(function (idx) {
            $(this).attr({
              role: 'group',
              'aria-roledescription': 'slide',
              'aria-label': `Slide ${idx + 1} of ${total}`
            });
          });
        };

        // --- A11y helper: keep only the active slide focusable/visible to AT -----
        // We remove focus from everything inside non-active slides so users don't
        // tab into "aria-hidden" content (classic carousel bug).
        const FOCUSABLE = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

        const updateSlidesA11y = (e, slick, current) => {
          const cur = (typeof current === 'number') ? current : slick.currentSlide;
          const $slides = $(slick.$slides);

          // 1) Hide all slides from screen readers + take them out of tab order.
          //    inert: modern browsers block focus/AT/pointer. We still set tabindex
          //    as a fallback/safety net. If you support very old browsers, consider
          //    a small inert polyfill.
          $slides
            .attr('aria-hidden', 'true')
            .attr('inert', '')
            .attr('tabindex', -1)
            .find(FOCUSABLE).each(function () {
              const $el = $(this);
              if ($el.data('orig-tabindex') === undefined) {
                $el.data('orig-tabindex', $el.attr('tabindex'));
              }
              $el.attr('tabindex', -1);
            });

          // 2) Expose only the current slide to AT and restore focusability inside.
          const $active = $slides.eq(cur)
            .attr('aria-hidden', 'false')
            .removeAttr('inert')
            .removeAttr('tabindex'); // keep the container itself out of the tab order

          $active.find(FOCUSABLE).each(function () {
            const $el = $(this);
            const orig = $el.data('orig-tabindex');
            if (orig === undefined || orig === null) {
              $el.removeAttr('tabindex');
            } else {
              $el.attr('tabindex', orig);
            }
          });
        };

        // Wire up labels + a11y state on init and after each change.
        slider
          .on('init reInit', function (e, slick) {
            // Announce slider purpose (nice for SR users).
            slider.attr({
              role: 'region',
              'aria-roledescription': 'carousel',
              'aria-label': slider.data('ariaLabel') || 'Carousel' // optional hook
            });

            labelSlides(slick);
            labelVideoLinks(slider);

            if (videoSlider) {
              updateSlidesA11y(e, slick);
            }

            // If dots are enabled on this slider, label them for SRs.
            if (slick.$dots) {
              $(slick.$dots).find('button').each(function (i) {
                $(this).attr('aria-label', `Go to slide ${i + 1}`);
              });
            }
          })
          .on('afterChange', function (e, slick, current) {
            // Slide count doesn't change, but a relabel keeps things consistent.
            labelSlides(slick);
            if (videoSlider) {
              updateSlidesA11y(e, slick, current);
            }
          });

        // Slick setup
        // Note: autoplay is OFF by design (accessibility-friendly).
        slider.slick({
          autoplay: false,
          autoplaySpeed: 5000, // ignored with autoplay:false; kept if toggled later
          dots: videoSlider ? false : true,
          centerMode: videoSlider ? true : false,
          centerPadding: videoSlider ? '0px' : '0px',
          focusOnSelect: videoSlider ? true : false,
          useTransform: videoSlider ? false : true,

          // Real <button> controls so arrows are keyboard-accessible.
          prevArrow: `
            <button type="button" class="btn-slider arrow-left" aria-label="Previous slide">
              <svg class="svg-inline--fa fa-chevron-down fa-w-14 select-chevron"
                  aria-hidden="true" focusable="false"
                  data-prefix="fal" data-icon="chevron-down"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16">
                <path fill="#331C86" d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"></path>
              </svg>
            </button>
          `,
          nextArrow: `
            <button type="button" class="btn-slider arrow-right" aria-label="Next slide">
              <svg class="svg-inline--fa fa-chevron-down fa-w-14 select-chevron"
                  aria-hidden="true" focusable="false"
                  data-prefix="fal" data-icon="chevron-down"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16">
                <path fill="#331C86" d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"></path>
              </svg>
            </button>
          `,

          infinite: careerSlider ? false : true,

          // slidesToShow priority:
          // - careers: 1.2 (peeking)
          // - video:   3 on desktop
          // - default: data attribute or 3
          slidesToShow: careerSlider
            ? 1.2
            : (videoSlider ? 3 : (slider.attr("data-slides-displayed") || 3)),

          slidesToScroll: 1,

          // For the video carousel we center the middle item to start.
          initialSlide: videoSlider ? 1 : 0,

          // Tweak counts per breakpoint. Keep center padding on small screens
          // for the video slider to hint more content is off-screen.
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: careerSlider
                  ? 1.2
                  : (slider.attr("data-slides-displayed") || 3)
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: videoSlider ? 3 : 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerPadding: videoSlider ? '80px' : '0px'
              }
            }
          ]
        });
      });
    }


    // Mobile component collapsible mode.
    if ($(window).width() < 768) {
      $(".mobile-collapse-component").each(function(i, elem) {
        const collapseLabel = $(elem).attr("data-collapse-mode-label");
        const collapsePreset = elem.className.match(/background-(.*) /)[1];

        // Wrap the component in the collapsible.
        $(elem).wrap(
          '<div class="mobile-collapsible mobile-collapsible-' +
            i +
            " background-" +
            collapsePreset +
            '"><div class="collapse collapsible-content"></div></div>'
        );

        // Prepend the collapsible label.
        $(".mobile-collapsible-" + i).prepend(
          '<div class="collapsible-label" data-target=".mobile-collapsible-' +
            i +
            ' > .collapse" data-toggle="collapse"><h2>' +
            collapseLabel +
            "</h2></div>"
        );

        // Append the collapsible icons.
        const $collapseContainer = $(elem).parents(".mobile-collapsible");
        const iconColor = $collapseContainer
          .find(".collapsible-label h2")
          .css("color");
        $collapseContainer.append(
          '<span class="plus collapse-icon" style="color: ' +
            iconColor +
            ';"></span>'
        );
        $collapseContainer.append(
          '<span class="minus collapse-icon" style="color: ' +
            iconColor +
            ';"></span>'
        );

        // Set the correct background color for the use-case component (exception).
        if ($(elem).find(".use-case").length) {
          $collapseContainer.addClass("use-case-mobile-collapse");
        }
        // If a slider is in the collapsible, refresh it after it has been shown.
        const $slider = $(elem).find(".slider");
        if ($slider.length) {
          $(".mobile-collapsible-" + i).on("shown.bs.collapse", function() {
            $slider.slick("refresh");
          });
        }

        // If there's a bleeding container on top of the collapsed component, disable the bleeding.
        elem.classList.forEach(c => {
          const match = /bleeding-container-(.*)$/.exec(c);
          if (match) {
            const bleedingDirection = match[1];
            const target =
              bleedingDirection == "bottom"
                ? $collapseContainer.prev()
                : $collapseContainer.next();
            target.find(".bleeding-column").removeClass("bleeding-column");
            target.find(".bleeding").removeClass("bleeding");
          }
        });
      });
    }
    // AOS animations.
    AOS.init({
      disable: "mobile"
    });
  }), 1);

})(jQuery, Drupal);
